import {BrickSnake2000Symbol, SymbolArgs} from "./BrickSnake2000Symbol";
import {BrickSnake2000} from "../../BrickSnake2000";
import {BrickSnake2000GameAssets} from "../../BrickSnake2000GameAssets";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {gsap} from "gsap";

export class FreespinsEgg extends BrickSnake2000Symbol {
    private landAnimation:PIXI.spine.Spine;
    constructor(args:SymbolArgs) {
        super(args);

        this.landAnimation =
            new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.FS_EGG));
        this.view.addChild(this.landAnimation);
    }

    public getLandAnimation(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.landAnimation.alpha = 1;
                this.mainSprite.alpha = 0;
                this.moveToWinLayer();
            })
            .add(SpineGSAPWrapper.createTimeline(this.landAnimation, 0, `SE_Land`))
            .add(() => {
                this.landAnimation.alpha = 0;
                this.mainSprite.alpha = 1;
                this.moveToNormalLayer();
            })
    }
}
